module.exports = __webpack_public_path__ + "img/oeuf.09cc4d72.svg";